module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp-fm"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_11",
      "title": "11"
    }
  }, [_vm._v("Leon Battista Alberti answers the question in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Della Famiglia,")]), _vm._v(" written in the 1430s. Since the family is the social unit par excellence, Alberti says, any attitude or treatment that benefits your family or serves to increase its honor is acceptable, for this is the defining purpose of life.")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("—TIM PARKS,")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("MEDICI MONEY: BANKING, METAPHYSICS,")]), _c('br'), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("AND ART IN FIFTEENTH-CENTURY FLORENCE")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(",")]), _c('br'), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("ATLAS/NORTON 2005, P. 26")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 78
// module chunks = 0